'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _reactI18next = require('react-i18next');

var _components = require('components');

var _reactRouterRedux = require('react-router-redux');

var _projects = require('selectors/projects');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _ProjectIrefTooltip = require('components/ProjectIrefTooltip/ProjectIrefTooltip');

var _ProjectIrefTooltip2 = _interopRequireDefault(_ProjectIrefTooltip);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var SSProjectsList = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    deleteSSProjectActionData: state.project.deleteSSProjectActionData,
    deleteSSProjectLoading: state.project.deleteSSProjectLoading,
    ssProjectsList: (0, _projects.getSharespaceProjects)(state),
    ssProjectsListLoading: state.project.ssProjectsListLoading,
    user: state.auth.user
  };
}, (0, _extends3.default)({}, projectActions, { pushState: _reactRouterRedux.push })), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(SSProjectsList, _Component);

  function SSProjectsList() {
    var _ref;

    (0, _classCallCheck3.default)(this, SSProjectsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = SSProjectsList.__proto__ || (0, _getPrototypeOf2.default)(SSProjectsList)).call.apply(_ref, [this].concat(args)));

    _this.state = { ssProjectsListPopoverHideDelete: false };
    return _this;
  }

  (0, _createClass3.default)(SSProjectsList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          projectId = _props.projectId,
          loadSSProjects = _props.loadSSProjects;

      loadSSProjects(projectId);
    }
  }, {
    key: 'gotoProject',
    value: function gotoProject(project) {
      this.props.pushState('/projects/' + project.audiovideo + '/' + project.id + '/materials');
    }
  }, {
    key: 'deleteProject',
    value: function deleteProject(project) {
      var _props2 = this.props,
          deleteSSProject = _props2.deleteSSProject,
          t = _props2.t;

      var toastrConfirmOptions = {
        onOk: function onOk() {
          return deleteSSProject(project.id);
        }
      };
      _toastr2.default.confirm(t('Are you sure you want to delete this project?'), toastrConfirmOptions);
    }
  }, {
    key: 'toggleSSProjectsListPopover',
    value: function toggleSSProjectsListPopover(e, project) {
      var user = this.props.user;

      this.setState({ ssProjectsListPopoverHideDelete: project.owId !== user.userId });
      this.ssProjectsListPopover.toggle(e, project);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          t = _props3.t,
          ssProjectsList = _props3.ssProjectsList,
          ssProjectsListLoading = _props3.ssProjectsListLoading,
          deleteSSProjectLoading = _props3.deleteSSProjectLoading,
          deleteSSProjectActionData = _props3.deleteSSProjectActionData;

      var showSSProjectLoader = function showSSProjectLoader(project) {
        return deleteSSProjectLoading && deleteSSProjectActionData.projectId === project.id;
      };
      var ssProjectsListPopoverHideDelete = this.state.ssProjectsListPopoverHideDelete;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _components.List,
          { className: 'margin-bottom-20' },
          _react2.default.createElement(
            _components.ListItem,
            { fullWidth: true, isTitle: true },
            _react2.default.createElement(
              'div',
              null,
              t('Package')
            ),
            _react2.default.createElement('div', null),
            _react2.default.createElement(
              'div',
              null,
              t('Status')
            ),
            _react2.default.createElement('div', null)
          ),
          ssProjectsList.map(function (project) {
            return _react2.default.createElement(
              _components.ListItem,
              { fullWidth: true, key: project.id },
              _react2.default.createElement(
                'div',
                null,
                project.fullTitle,
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'span',
                  { className: 'text-muted' },
                  t('Created by: {{owner}}', { owner: project.owName }),
                  '. ',
                  t('{{count}} recipients', { count: Number(project.nbreceps) })
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_ProjectIrefTooltip2.default, { iRef: project.iRef })
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_components.ProjectStatus, { status: project.status })
              ),
              _react2.default.createElement(
                'div',
                { className: 'moreCell' },
                _react2.default.createElement('i', { className: 'more', onClick: function onClick(e) {
                    return _this2.toggleSSProjectsListPopover(e, project);
                  } }),
                showSSProjectLoader(project) && _react2.default.createElement(_components.Loader, { small: true, mask: true })
              )
            );
          })
        ),
        ssProjectsListLoading && _react2.default.createElement(_components.Loader, null),
        _react2.default.createElement(
          _components.PopoverMenu,
          { id: 'ssProjectsListPopover', ref: function ref(el) {
              return _this2.ssProjectsListPopover = el;
            } },
          _react2.default.createElement(
            'li',
            { onClick: function onClick() {
                return _this2.gotoProject(_this2.ssProjectsListPopover.data);
              } },
            t('Edit'),
            _react2.default.createElement('i', { className: 'icon-mode-edit' })
          ),
          _react2.default.createElement(
            'li',
            { onClick: function onClick() {
                return _this2.deleteProject(_this2.ssProjectsListPopover.data);
              }, hidden: ssProjectsListPopoverHideDelete },
            t('Delete'),
            _react2.default.createElement('i', { className: 'icon-delete' })
          )
        )
      );
    }
  }]);
  return SSProjectsList;
}(_react.Component), _class3.propTypes = {
  deleteSSProject: _propTypes2.default.func,
  deleteSSProjectActionData: _propTypes2.default.object,
  deleteSSProjectLoading: _propTypes2.default.bool,
  loadSSProjects: _propTypes2.default.func,
  projectId: _propTypes2.default.number.isRequired,
  pushState: _propTypes2.default.func,
  ssProjectsList: _propTypes2.default.array,
  ssProjectsListLoading: _propTypes2.default.bool,
  t: _propTypes2.default.func,
  user: _propTypes2.default.object
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'toggleSSProjectsListPopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleSSProjectsListPopover'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = SSProjectsList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Project/SSProjects/SSProjectsList.js
// module id = 2050
// module chunks = 1